import { useState, useEffect, Fragment } from "react";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Moment from "react-moment";
import FleetWebApi from "../Api/FleetWebApi";
import { useAuthDataContext } from "../AuthDataProvider";

function RmaDeviceSummary(props) {
  const [rmaData, setRmaData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const { user } = useAuthDataContext();
  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    FleetWebApi.getRmaBySerial(props.serial, user.token)
      .then((response) => {
        if (isMounted) {
          setRmaData(response);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        if (isMounted) {
          setError(error.message);
          setIsLoading(false);
        }
      });
    return () => {
      isMounted = false;
      setRmaData([]);
    };
  }, [props.serial]);

  return (
    <Fragment>
      <h3>Device RMA Details</h3>
      <Paper>
        {isLoading ? (
          <CircularProgress color="secondary" />
        ) : !isLoading && error ? (
          error
        ) : !isLoading && !error && rmaData.length > 0 ? (
          <Table classes={{ root: "reactivetable" }}>
            <TableHead>
              <TableRow>
                <TableCell>RMA Number</TableCell>
                <TableCell>RMA Return Date</TableCell>
                <TableCell>Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rmaData.map((data, key) => (
                <TableRow key={key}>
                  <TableCell data-th="RMA Number">{data.RMANumber}</TableCell>
                  <TableCell data-th="RMA Return Date">
                    {data.RMAOpened ? (
                      <Moment format="YYYY-MM-DD HH:mm:ss Z">
                        {data.RMAOpened}
                      </Moment>
                    ) : (
                      <div>-</div>
                    )}
                  </TableCell>
                  <TableCell data-th="RMA Details">
                    {data.issueDetails}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : !isLoading && !error && rmaData.length === 0 ? (
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>No RMA Data Found</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        ) : null}
      </Paper>
    </Fragment>
  );
}

export default RmaDeviceSummary;
